import { ScreenContext } from '@/contexts/ScreenContext';
import { TypographyProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import { CSSProperties, useContext, useEffect, useState } from 'react';

const DEFAULT_BASE_FONT_SIZE = 16;

export enum FontType {
    Normal,
    MainBet,
    SideBet,
}

type RwdTypographyLobbyProps = TypographyProps & {
    stepIndex?: number; // (portrait) from figma (Designer)
    landscapeStepIndex?: number; // (landscape) from figma (Designer)
    extraFontFactor?: number;
    minFactor?: number;
};

export const RwdTypographyLobby = (props?: RwdTypographyLobbyProps) => {
    const {
        children,
        sx,
        stepIndex = undefined,
        landscapeStepIndex = undefined,
        extraFontFactor = 1,
        minFactor = 0.8,
        ...rest
    } = props || {};

    const { isLandscape, scaleFactor } = useContext(ScreenContext);

    const getFontSize = () => {
        let newFontSize: number = DEFAULT_BASE_FONT_SIZE;

        if (stepIndex !== undefined) {
            let idx: number = stepIndex;

            if (landscapeStepIndex !== undefined && isLandscape) {
                idx = landscapeStepIndex;
            }

            switch (idx) {
                case -3:
                    newFontSize = !isLandscape ? 10 : 12;
                    break;
                case -2:
                    newFontSize = !isLandscape ? 12 : 14;
                    break;
                case -1:
                    newFontSize = !isLandscape ? 14 : 16;
                    break;
                case 0:
                    newFontSize = !isLandscape ? 16 : 18;
                    break;
                case 1:
                    newFontSize = !isLandscape ? 18 : 20;
                    break;
                case 2:
                    newFontSize = !isLandscape ? 20 : 24;
                    break;
                case 3:
                    newFontSize = !isLandscape ? 22 : 28;
                    break;
                case 4:
                    newFontSize = !isLandscape ? 24 : 32;
                    break;
                case 5:
                    newFontSize = !isLandscape ? 28 : 36;
                    break;
                case 6:
                    newFontSize = !isLandscape ? 32 : 40;
                    break;
                case 7:
                    newFontSize = !isLandscape ? 38 : 48;
                    break;
                case 7.5:
                    newFontSize = !isLandscape ? 50 : 64;
                    break;
                case 8:
                    newFontSize = !isLandscape ? 56 : 72;
                    break;
            }
            if (scaleFactor > minFactor) {
                newFontSize *= scaleFactor;
            } else {
                newFontSize *= minFactor;
            }
        }

        return `${newFontSize * extraFontFactor}px`;
    };

    const [rwdFontSize, setRwdFontSize] = useState<string | undefined>(
        getFontSize()
    );

    useEffect(() => {
        setRwdFontSize(getFontSize());
    }, [scaleFactor, isLandscape, extraFontFactor]);

    return (
        <Typography
            sx={{ ...(sx as CSSProperties), fontSize: rwdFontSize }}
            {...rest}
        >
            {children}
        </Typography>
    );
};
